import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromAppRoot from '@app/app.reducers';

@Injectable({
  providedIn: 'root'
})
class GermanyNotAllowedGuardService {
  protected readonly onDestroy$ = new Subject<void>();
  constructor(
    private router: Router,
    private store: Store
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Observable((observer) => {
      this.store
        .pipe(select(fromAppRoot.selectCustomerAndCurrentAccount))
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((value) => {
          if (!value || !value.customer || !value.customer.email) {
            return;
          }

          if (value.customer.app_location !== 'ch') {
            observer.next(this.router.parseUrl('/'));
          } else {
            observer.next(true);
          }
          this.onDestroy$.next();
          this.onDestroy$.complete();
        });
    });
  }
}

export const GermanyNotAllowedGuard: CanActivateFn = () => {
  return inject(GermanyNotAllowedGuardService).canActivate();
};
